import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { TkValidator } from 'src/app/validator/tk.validator';
import { Location } from '@angular/common';

@Component({
  selector: 'app-new-company-request',
  templateUrl: './new-company-request.component.html',
  styleUrls: ['./new-company-request.component.scss'],
})
export class NewCompanyRequestComponent implements OnInit {
  @Input() newCompanyName: any;
  newCompanyForm: UntypedFormGroup;
  page = 1;
  plan: string;
  isAdvance: boolean;
  isPremium: boolean;
  isFree: boolean;
  emailId: string;
  localStorage: any;
  isNCR: any = 'false';

  constructor(public companyService: CompanyService,
    public localStorageService: LocalStorageService,
    public tansactionService: TansactionService,
    public loginSignupService: LoginSignupService,
    public toastService: ToastService,
    private _location: Location,
    private router: Router) {
    this.newCompanyForm = new UntypedFormGroup({
      company_name: new UntypedFormControl('', [Validators.required]),
      website: new UntypedFormControl('', [Validators.required, TkValidator.url]),
      cin: new UntypedFormControl('', [
        Validators.minLength(21),
        Validators.maxLength(21),
        TkValidator.noWhiteSpace,
      ]),
      name: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
      ]),
      email: new UntypedFormControl({ value: '', disabled: true }, [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    this.emailId = this.loginSignupService.getUserSession()?.user?.email;
    this.getNCRValue();
    if (this.emailId) {
      this.newCompanyForm.patchValue({ company_name: this.newCompanyName });
      this.newCompanyForm.patchValue({ email: this.emailId });
    } else {
      this.router.navigate(['/user/login']);
    }
  }

  getNCRValue(){
    let requestData = {
      emailId : this.emailId
    }
    this.companyService.newCompanyDataValue(requestData).then(
      (data: any) => {
        this.isNCR = data;
      },
      (err) => { }
    );
  }

  submit() {
    this.companyService.newCompanyData(this.newCompanyForm.getRawValue()).then(
      (data: any) => {
        if (data.product) {
          this.addToCart(data.product.sku)
        } else {
          this.page = 2;
        }
      },
      (err) => { }
    );
  }

  addToCart(sku) {
    let currentOption;
    currentOption = {
      sku: sku,
    };
    this.tansactionService.addProductToCart(currentOption).then(
      (data: any) => {
        this.toastService.addSingle(
          'success',
          'Item added to cart',
          'Make payment to complete this transaction.'
        );
        this.router.navigate(['/cart']);
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }
  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
